module.exports = __webpack_public_path__ + "img/rto_invoice_amount.7c975b42.svg";